import style from "../../styles/bottombar.module.css";
import { useTranslation } from "react-i18next";

/**
 * The footer.
 *
 * Shows the product name only. The build version used to sit here, which told an
 * applicant nothing and told anyone else which build they were probing.
 */
const BottomBar = () => {
  const { t } = useTranslation();
  return <div className={style.bottombar}>{t("identity_verification")}</div>;
};

export default BottomBar;
